import React, { useEffect, useRef, useState } from "react";
import { Box, Modal } from "@mui/material";
import { useTour } from "../../context/TourContext";
import {
  DEBOUNCE_DELAY,
  EMITTER_ERROR,
  EMITTER_SUCCESS,
  contactListHeadData,
} from "../../utils/constants";
import { useNavigate, createSearchParams, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  importEndpoints,
  listEndPoints,
} from "../../utils/constants/httpConstants";
import { getRequest, postRequest, putRequest } from "../../Apis/apiWrapper";
import EventEmitter from "../../utils/emitter/EventEmitter";
import BulkDeleteModal from "./components/Template/BulkDeleteModal";
import CreateCommonFolder from "./components/common/CreateCommonFolder";
import {
  debounceHelper,
  generateBreadCrumbDescription,
  getErrorMessage,
} from "../../utils/helpers";
import { getContactListData } from "../../redux/actions/contactListactions";
import RemoveFolder from "./components/common/RemoveFolder";
import {
  LIST_PATH,
  MARKETING_PROSPECT_SCREEN_PATH,
  PEOPLE_SCREEN_PATH,
} from "../../utils/constants/routes";
import { STRINGS } from "./strings";
import { Button } from "../../components/Buttons";
import { ICON_LABELS, fontSize, fontWeight } from "../../utils/constants/UI";
import SearchField from "../../components/InputFields/SearchField";
import { GREY, WARNING } from "../../utils/constants/colors";
import TypographyInline from "../../components/Typography/TypographyInline";
import CustomTable from "../../components/Table/CustomTable";
import ListDeleteFolderModal from "./components/Lists/ListDeleteFolderModal";
import { tableEndpointChange } from "../../redux/actions/tableActions";
import { allFilters } from "../../redux/actions/filterActions";
import CustomHeader from "../../components/Header/CustomHeader";
import { paginationDataAction } from "../../redux/actions/customTableActions";
import CreateListModal from "./components/Lists/CreateListModal";
import MappingFieldModal from "../CRM/Contacts/components/MappingFieldModal";
import { IMPORT_COLUMN_PEOPLE_PROPERTY_COLUMNS } from "../../utils/constants";
import {
  FILE_SIZE_ERROR,
  INVALID_FILE_ERROR,
} from "../../utils/constants/messages";
import CustomStyledMenu from "../../components/Menu/CustomStyledMenu";
import FolderSkeletonLoader from "./components/common/FolderSkeletonLoader";
import IconComponent from "../../components/Icon/IconComponent";
import {
  DEFAULT_ERROR_MESSAGE,
  SELECT_ATLEAST_LIST,
  SELECT_FOLDER,
  SELECT_LIST,
} from "../../utils/constants/messages";
import classes from "./marketing.module.css";
import EmptyScreen from "./EmptyScreen";

const LISTS_TOUR_DUMMY_RECORDS = [
  { _id: "dummy_1",  list_name: "Q2 Enterprise Prospects",    owner_name: "Sarah Mitchell",  user_id: "u1", count: 1842, permission: "public",  created_at: "2025-03-12T09:15:00Z", updated_at: "2025-06-20T14:30:00Z", type: "file", pin: 0 },
  { _id: "dummy_2",  list_name: "SaaS Decision Makers",       owner_name: "Daniel Okafor",   user_id: "u2", count: 973,  permission: "private", created_at: "2025-04-01T11:00:00Z", updated_at: "2025-06-18T09:45:00Z", type: "file", pin: 0 },
  { _id: "dummy_3",  list_name: "Mid-Market CFOs US",          owner_name: "Priya Sharma",    user_id: "u3", count: 540,  permission: "public",  created_at: "2025-01-20T08:30:00Z", updated_at: "2025-06-15T16:10:00Z", type: "file", pin: 0 },
  { _id: "dummy_4",  list_name: "Inbound Leads — May 2025",   owner_name: "James Thornton",  user_id: "u4", count: 2310, permission: "public",  created_at: "2025-05-01T07:00:00Z", updated_at: "2025-06-14T11:20:00Z", type: "file", pin: 0 },
  { _id: "dummy_5",  list_name: "Healthcare VPs",             owner_name: "Lisa Carvalho",   user_id: "u5", count: 387,  permission: "private", created_at: "2025-02-14T13:45:00Z", updated_at: "2025-06-10T10:00:00Z", type: "file", pin: 0 },
  { _id: "dummy_6",  list_name: "Webinar Attendees — Q1",     owner_name: "Marcus Reid",     user_id: "u6", count: 1205, permission: "public",  created_at: "2025-01-08T10:30:00Z", updated_at: "2025-06-09T15:55:00Z", type: "file", pin: 0 },
  { _id: "dummy_7",  list_name: "Series B Funded Startups",   owner_name: "Anjali Patel",    user_id: "u7", count: 620,  permission: "public",  created_at: "2025-03-25T09:00:00Z", updated_at: "2025-06-08T12:40:00Z", type: "file", pin: 0 },
  { _id: "dummy_8",  list_name: "Re-Engagement Cold Leads",   owner_name: "Sarah Mitchell",  user_id: "u1", count: 892,  permission: "private", created_at: "2025-04-10T14:00:00Z", updated_at: "2025-06-07T09:30:00Z", type: "file", pin: 0 },
  { _id: "dummy_9",  list_name: "E-commerce CTOs",            owner_name: "Nathan Brooks",   user_id: "u8", count: 458,  permission: "public",  created_at: "2025-02-28T11:15:00Z", updated_at: "2025-06-06T17:00:00Z", type: "file", pin: 0 },
  { _id: "dummy_10", list_name: "EMEA Sales Directors",        owner_name: "Priya Sharma",    user_id: "u3", count: 734,  permission: "public",  created_at: "2025-01-15T08:00:00Z", updated_at: "2025-06-05T13:20:00Z", type: "file", pin: 0 },
  { _id: "dummy_11", list_name: "Demo Requests — June",       owner_name: "Daniel Okafor",   user_id: "u2", count: 316,  permission: "private", created_at: "2025-06-01T09:30:00Z", updated_at: "2025-06-04T10:45:00Z", type: "file", pin: 0 },
  { _id: "dummy_12", list_name: "FinTech VPs of Engineering", owner_name: "Lisa Carvalho",   user_id: "u5", count: 281,  permission: "public",  created_at: "2025-03-05T12:00:00Z", updated_at: "2025-06-03T16:30:00Z", type: "file", pin: 0 },
  { _id: "dummy_13", list_name: "Enterprise AE Targets",      owner_name: "James Thornton",  user_id: "u4", count: 1490, permission: "public",  created_at: "2025-02-10T07:45:00Z", updated_at: "2025-06-02T11:10:00Z", type: "file", pin: 0 },
  { _id: "dummy_14", list_name: "Conference Leads SaaStr",    owner_name: "Marcus Reid",     user_id: "u6", count: 667,  permission: "private", created_at: "2025-04-22T15:30:00Z", updated_at: "2025-06-01T09:00:00Z", type: "file", pin: 0 },
  { _id: "dummy_15", list_name: "SMB Owners — Retail",        owner_name: "Nathan Brooks",   user_id: "u8", count: 1120, permission: "public",  created_at: "2025-01-30T10:00:00Z", updated_at: "2025-05-30T14:00:00Z", type: "file", pin: 0 },
  { _id: "dummy_16", list_name: "Churned Customers — 2024",   owner_name: "Anjali Patel",    user_id: "u7", count: 210,  permission: "private", created_at: "2025-02-05T08:30:00Z", updated_at: "2025-05-28T12:50:00Z", type: "file", pin: 0 },
  { _id: "dummy_17", list_name: "Product-Led Growth Segment", owner_name: "Sarah Mitchell",  user_id: "u1", count: 944,  permission: "public",  created_at: "2025-03-18T13:00:00Z", updated_at: "2025-05-26T10:20:00Z", type: "file", pin: 0 },
  { _id: "dummy_18", list_name: "Logistics & Supply Chain",   owner_name: "James Thornton",  user_id: "u4", count: 505,  permission: "public",  created_at: "2025-04-14T09:45:00Z", updated_at: "2025-05-24T15:35:00Z", type: "file", pin: 0 },
  { _id: "dummy_19", list_name: "APAC Enterprise Q2",          owner_name: "Priya Sharma",    user_id: "u3", count: 378,  permission: "private", created_at: "2025-05-10T11:30:00Z", updated_at: "2025-05-22T08:55:00Z", type: "file", pin: 0 },
  { _id: "dummy_20", list_name: "ICP Matched — AI Tools",     owner_name: "Daniel Okafor",   user_id: "u2", count: 1657, permission: "public",  created_at: "2025-04-28T14:15:00Z", updated_at: "2025-05-20T13:10:00Z", type: "file", pin: 0 },
];

const ListsScreen = () => {
  const navigate = useNavigate();

  // Importing straight into the list the rep is looking at. The file chooser and
  // the mapping modal open here rather than sending them to the import screen,
  // which meant leaving the list to come back to it.
  const importInputRef = useRef(null);
  const [importList, setImportList] = useState(null);
  const [importFile, setImportFile] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importDynamicFields, setImportDynamicFields] = useState(
    IMPORT_COLUMN_PEOPLE_PROPERTY_COLUMNS || [],
  );
  const [importPeopleFields, setImportPeopleFields] = useState([]);
  const [importCompanyFields, setImportCompanyFields] = useState([]);
  const [importPeopleCustomFields, setImportPeopleCustomFields] = useState([]);
  const [importCompanyCustomFields, setImportCompanyCustomFields] = useState([]);

  const startImportIntoList = (row) => {
    setImportList({ id: row?._id, name: row?.list_name });
    if (importInputRef.current) {
      importInputRef.current.value = "";
      importInputRef.current.click();
    }
  };

  const handleImportFileUpload = (event) => {
    const chosen = event?.target?.files?.[0];
    const sizeInMb = (chosen?.size || 0) / (1024 * 1024);
    if (sizeInMb >= 1024) {
      EventEmitter.emit(EMITTER_ERROR, FILE_SIZE_ERROR);
      event.target.value = "";
      return;
    }
    if (chosen?.type !== "text/csv") {
      EventEmitter.emit(EMITTER_ERROR, INVALID_FILE_ERROR);
      event.target.value = "";
      return;
    }
    setImportFile(chosen);
    setShowImportModal(true);
    event.target.value = "";
  };

  // The mapping modal needs the workspace's fields. Fetched once here, the same
  // way the import screen does it.
  useEffect(() => {
    (async () => {
      try {
        const response = await getRequest(
          navigate,
          importEndpoints.getCrmFieldlMapping,
        );
        const records = response?.data?.data || {};
        setImportPeopleFields([...(records?.people_predefined_field || [])]);
        setImportCompanyFields([...(records?.company_predefined_field || [])]);
        setImportPeopleCustomFields([...(records?.people_custom_field || [])]);
        setImportCompanyCustomFields([...(records?.company_custom_field || [])]);
        setImportDynamicFields(IMPORT_COLUMN_PEOPLE_PROPERTY_COLUMNS || []);
      } catch (error) {
        // Not fatal: the action simply will not be able to map custom fields.
        console.log("import field mapping", error);
      }
    })();
  }, [navigate]);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open1 = Boolean(anchorEl);
  const { id } = useParams();
  const [isActive, setIsActive] = useState("");
  const [isLoad, setIsLoad] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [bulkDelete, setBulkDelete] = useState(false);
  const [isLoadData, setIsLoadData] = useState(false);
  const [openList, setOpenList] = useState(false);
  const [removeFolder, setRemoveFolder] = useState(false);
  const [getMoveData, setGetMoveData] = useState([]);
  const [folderEddit, setFolderEddit] = useState("");
  const [itemId, setItemId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteModal1, setShowDeleteModal1] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditModal1, setShowEditModal1] = useState(false);
  const [editInitialValue, setEditInitialValue] = useState("");
  const [delName, setDelName] = useState(null);
  const [deletePayload, setDeletePayload] = useState(null);
  const [viewType, setViewType] = useState("");
  const [myRecord, setMyRecord] = useState();
  const [myName, setMyName] = useState("");
  const [view, setView] = useState("");
  const [permission, setPermission] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [isMount, setIsMount] = useState(false);
  const [isOperationPermitted, setIsOperationPermitted] = useState(true);
  const [headerItems, setHeaderItems] = useState([
    { id: STRINGS.LIST_TEXT, label: STRINGS.LIST_TEXT, path: LIST_PATH },
  ]);
  const { activeTourKey } = useTour();
  const isListsTourActive = activeTourKey === "marketing_list" || activeTourKey === "campaigns";

  const sortSelector = useSelector((state) => state.getPaginationQuery);
  const getContactListSelector = useSelector(
    (state) => state.getContactDataList,
  );
  const userDetailsSelector = useSelector((state) => state?.userDetails);

  const handleEdit = async (list, val) => {
    setFolderEddit(val);
    setItemId(list?._id);
    setEditInitialValue(list?.list_name);
    setViewType(list?.permission);
    setShowEditModal(true);
  };

  const handleDelete = async (list, val) => {
    setFolderEddit(val);
    setShowDeleteModal(true);
    setDelName(list?.list_name);
    setDeletePayload(list?._id);
  };

  const deleteRecord = (row, head) => {
    handleClose();
    setMyRecord(row?._id);
    setMyName(row?.list_name);
    setShowDeleteModal1(true);
  };

  const editFolder = (row, head) => {
    setMyRecord(row?._id);
    setMyName(row?.list_name);
    setView(row?.permission);
    setShowEditModal1(true);
  };

  const openCreateModal = () => {
    setAnchorEl(null);
    setOpen2(true);
  };

  const backHandle = (id) => {
    setIsActive(id);
  };

  const removeListFolder = () => {
    if (sortSelector?.data?.checkedRow?.length > 0) {
      setRemoveFolder(true);
    } else {
      EventEmitter.emit(EMITTER_ERROR, SELECT_LIST);
    }
  };

  function handleBulkDelete() {
    if (sortSelector?.data?.checkedRow?.length > 0) {
      setBulkDelete(true);
    } else {
      EventEmitter.emit(EMITTER_ERROR, SELECT_LIST);
    }
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setIsActive("");
    setAnchorEl(null);
  };

  function handleFolder() {
    setOpen2(true);
  }

  const hitMoveList = async () => {
    try {
      setIsLoadData(true);
      if (userDetailsSelector?.payload?.role !== STRINGS.ADMIN_USER) {
        const rsp = await postRequest(navigate, listEndPoints.getMoveList, {
          owner_ids: [],
        });
        setGetMoveData(rsp?.data?.data?.records || []);
      } else {
        let userIdArr = getContactListSelector?.data?.data?.records
          ?.filter((item) =>
            sortSelector?.data?.checkedRow?.includes(item?._id),
          )
          ?.map((item) => {
            return item?.user_id;
          });
        const rsp = await postRequest(navigate, listEndPoints.getMoveList, {
          owner_ids: userIdArr,
        });
        setGetMoveData(rsp?.data?.data?.records || []);
      }
    } catch (error) {
    } finally {
      setIsLoadData(false);
    }
  };

  const filterMoveTemplate = async (valID) => {
    if (sortSelector?.data?.checkedRow?.length > 0 && valID) {
      try {
        const payload = {
          list_ids: sortSelector?.data?.checkedRow,
          parent: valID,
        };
        setIsLoad(true);
        const response = await putRequest(
          navigate,
          listEndPoints.moveToFolderList,
          payload,
        );

        EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
        navigate(`${LIST_PATH}/${valID}`);

        setIsLoad(false);
        setAnchorEl(null);
        setIsActive("");
        dispatch(getContactListData({ parent: id }, navigate));
        dispatch(paginationDataAction({ checkedRow: [] }));
      } catch (err) {
        EventEmitter.emit(
          EMITTER_ERROR,
          getErrorMessage(err?.data?.data?.errors || {}, err?.data?.message),
        );
        setIsLoad(false);
      }
    } else if (sortSelector?.data?.checkedRow?.length > 0) {
      EventEmitter.emit(EMITTER_ERROR, SELECT_FOLDER);
    } else {
      EventEmitter.emit(EMITTER_ERROR, SELECT_ATLEAST_LIST);
    }
  };

  const handleSearch = () => {
    try {
      // setSearchValue(event.target.value);
      dispatch(
        paginationDataAction({
          ...sortSelector?.data,
          checkedRow: [],
          query: {
            ...sortSelector?.data?.query,
            search: searchValue,
            page: 1,
          },
        }),
      );
    } catch (e) {
      EventEmitter.emit(EMITTER_ERROR, DEFAULT_ERROR_MESSAGE);
    }
  };

  const listTableData = {
    heads: contactListHeadData,
    body: isListsTourActive ? LISTS_TOUR_DUMMY_RECORDS : (getContactListSelector?.data?.data?.records || []),
    operations: [
      {
        id: STRINGS.SMALL_DELETE,
        label: STRINGS.DELETE,
        iconLabel: ICON_LABELS.DELETE,
        variant: "error",
        function: (row, head) => {
          if (row?.type === STRINGS.SMALL_FOLDER) deleteRecord(row, head);
          else handleDelete(row, head);
        },
      },
      {
        id: STRINGS.EDIT,
        label: STRINGS.COMMON_EDIT,
        iconLabel: ICON_LABELS.EDIT,
        function: (row, head) => {
          if (row?.type === STRINGS.SMALL_FOLDER) editFolder(row, head);
          else handleEdit(row, head);
        },
      },
      {
        // Reaching the import screen from the list the rep is already looking at,
        // rather than making them go to Import and find this list again in a
        // picker. Folders hold lists, not contacts, so there is nothing to import
        // into one.
        id: STRINGS.IMPORT_INTO_LIST,
        label: STRINGS.IMPORT_INTO_LIST,
        iconLabel: ICON_LABELS.FILE_UPLOAD,
        function: (row) => {
          if (row?.type === STRINGS.SMALL_FOLDER) return;
          startImportIntoList(row);
        },
      },
    ],
    actions: {
      marketing_list_icp: {
        function: (a, b) => {
          // dispatch empty rows.
          dispatch(paginationDataAction({}));

          if (a.type === STRINGS.FILE) {
            dispatch(tableEndpointChange(STRINGS.SAVED_CONTACTS));
            dispatch(allFilters({ contact_lists: [a?._id] }));
            dispatch(getContactListData({ type: STRINGS.FILE }, navigate));
            navigate({
              pathname: MARKETING_PROSPECT_SCREEN_PATH,
              search: createSearchParams({
                contact_lists: a?._id,
              }).toString(),
            });
          } else
            navigate(`${LIST_PATH}/${a._id}`, {
              state: {
                folderName: a?.list_name,
              },
            });
        },

        loading: true,
      },
    },
    sortHandler: {},
    total_records: isListsTourActive ? LISTS_TOUR_DUMMY_RECORDS.length : (getContactListSelector?.data?.total_records || 0),
    isLoading: isListsTourActive ? false : getContactListSelector?.loading,
    disable_key: STRINGS.DISABLE_KEY,
  };

  const isBulkOperationAllowed = (type = STRINGS.FILE) => {
    try {
      if (sortSelector?.data?.checkedRow?.length) {
        // check if only one type exists.
        const records = getContactListSelector?.data?.data?.records || [];
        const newRecords = [
          ...new Set(
            records
              .filter((item) =>
                sortSelector?.data?.checkedRow?.includes(item._id || item?.id),
              )
              ?.map((item) => item?.type),
          ),
        ];
        if (newRecords?.length >= 2) {
          return false;
        }
        if (
          type === STRINGS.SMALL_FOLDER &&
          newRecords.includes(`${STRINGS.SMALL_FOLDER}`)
        ) {
          return false;
        }

        // check for unique user_id in admin case.
        const selected_ids = sortSelector?.data?.checkedRow;
        const unique_records = [
          ...new Set(
            records
              ?.filter((item) => selected_ids.includes(item?._id))
              .map((item) => item?.user_id),
          ),
        ];
        if (unique_records?.length >= 2 && type === STRINGS.SMALL_FOLDER) {
          return false;
        }
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  const handleListCreate = () => {
    setOpenList(true);
  };

  const value = {
    create: STRINGS.CREATE_LISST,
    content: STRINGS.LIST_CONT,
    body: [STRINGS.LIST_BD],
    foot: STRINGS.CREATE_LISST,
  };

  const handleFolderSearch = async (e) => {
    e?.stopPropagation();
    try {
      let userIdArr = getContactListSelector?.data?.data?.records
        ?.filter((item) => sortSelector?.data?.checkedRow?.includes(item?._id))
        ?.map((item) => {
          return item?.user_id;
        });
      const role = userDetailsSelector?.payload?.role;
      setIsLoadData(true);
      const rsp = await postRequest(navigate, listEndPoints.getMoveList, {
        search: e.target.value,
        owner_ids: role === STRINGS.ADMIN_USER ? userIdArr : {},
      });
      setGetMoveData(rsp?.data?.data?.records || []);
    } catch (e) {
      EventEmitter.emit(EMITTER_ERROR, DEFAULT_ERROR_MESSAGE);
    } finally {
      setIsLoadData(false);
    }
  };

  const handleDebounceFolderSearch = debounceHelper(
    handleFolderSearch,
    DEBOUNCE_DELAY,
  );

  const getTypeFromIds = () => {
    const type = getContactListSelector?.data?.data?.records?.filter((item) =>
      sortSelector?.data?.checkedRow?.includes(item?._id || item?.id),
    )?.[0]?.type;
    return type;
  };

  const disableMoveTo = () => {
    const records = getContactListSelector?.data?.data?.records;
    const selected_ids = sortSelector?.data?.checkedRow;
    const unique_records = [
      ...new Set(
        records
          ?.filter((item) => selected_ids?.includes(item?._id))
          ?.map((item) => item?.user_id),
      ),
    ];
    if (unique_records?.length <= 1) {
      return true;
    }
    return false;
  };

  disableMoveTo();

  useEffect(() => {
    (async () => {
      try {
        if (id) {
          await dispatch(
            getContactListData({
              ...sortSelector?.data?.query,
              parent: id,
              // search: "",
            }),
          );

          // call folder detail api here and set header Items here.
          const get_folder_details_payload = await getRequest(
            navigate,
            listEndPoints.getFolderDetail + `?${STRINGS.ID}=${id}`,
          );

          console.log({ get_folder_details_payload }, headerItems, "YO");
          // condition to not add new header item on every re-render.
          const route_length = window.location.pathname
            ?.split(LIST_PATH)?.[1]
            ?.split("/");
          let new_header_items;
          headerItems?.length > 1 && headerItems.pop();
          new_header_items = [
            ...headerItems,
            {
              id: id,
              label: get_folder_details_payload?.data?.data?.list_name || "",
            },
          ];
          if (headerItems.length !== route_length.length) {
            setHeaderItems(new_header_items);
          }
          setIsOperationPermitted(
            get_folder_details_payload?.data?.data?.operation,
          );
          setPermission(get_folder_details_payload?.data?.data?.permission);
        } else {
          setIsOperationPermitted(true);
          setHeaderItems([
            {
              id: STRINGS.TYPE_TEMP,
              label: STRINGS.LIST_TEXT,
              path: LIST_PATH,
            },
          ]);

          await dispatch(
            getContactListData({ ...sortSelector?.data?.query }, navigate),
          );
        }
      } catch (error) {}
    })();
  }, [sortSelector?.data?.query, navigate]);

  useEffect(() => {
    setSearchValue("");
    setIsMount(false);
  }, [navigate]);

  // debounce search api call for search
  useEffect(() => {
    if (isMount) {
      let getData;
      getData = setTimeout(() => {
        handleSearch();
      }, 300);
      return () => clearTimeout(getData);
    } else {
      setIsMount(true);
    }
  }, [searchValue]);

  return (
    <>
      {/* Opened by the per-row Import action; never shown. */}
      <input
        ref={importInputRef}
        type="file"
        accept=".csv"
        onChange={handleImportFileUpload}
        style={{ display: "none" }}
      />
      <Modal open={showImportModal}>
        <MappingFieldModal
          file={importFile}
          setFile={setImportFile}
          open={showImportModal}
          setOpen={setShowImportModal}
          dynamicFields={importDynamicFields}
          peopleDynamicFields={importPeopleFields}
          companyDynamicFields={importCompanyFields}
          predefinedPeopleCustomFields={importPeopleCustomFields}
          predefinedCompanyCustomFields={importCompanyCustomFields}
          getImportedFilesList={() => {}}
          preselectedListId={importList?.id || ""}
          preselectedListName={importList?.name || ""}
        />
      </Modal>
      <Box className={classes.listContainer}>
        <CustomHeader
          items={headerItems}
          description={
            getContactListSelector?.loading
              ? STRINGS.LOADING
              : generateBreadCrumbDescription(getContactListSelector?.data)
          }
        />
        {!isListsTourActive && getContactListSelector?.data?.is_empty ? (
          <EmptyScreen
            data={value}
            handleOpen={handleListCreate}
            handleFolder={handleFolder}
          />
        ) : (
          <>
            <Box className={classes.templateSearchContainer}>
              <Box className={classes.templateSearchLeft}>
                <Box className={classes.commonWidth}>
                  <SearchField
                    autoComplete="off"
                    size={"sm36"}
                    value={searchValue}
                    placeholder={STRINGS.SEARCH_LIST}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                  />
                </Box>

                {!isBulkOperationAllowed(STRINGS.SMALL_FOLDER) ? null : (
                  <div onClick={hitMoveList}>
                    <Button
                      label={STRINGS.MOVE_TO}
                      LeftIcon={ICON_LABELS.DRIVE_FILE_MOVE}
                      variant={"ghost"}
                      size={"sm36"}
                      disabled={!isBulkOperationAllowed(STRINGS.SMALL_FOLDER)}
                      onClick={
                        sortSelector?.data?.checkedRow?.length
                          ? handleClick
                          : () => {}
                      }
                    />
                  </div>
                )}

                <CustomStyledMenu
                  width="400px"
                  anchorEl={anchorEl}
                  open={open1}
                  onClose={handleClose}
                >
                  <Box className={classes.movingContainer}>
                    <Box className={classes.movingHeader}>
                      <Box className={classes.moveStyle}>
                        <TypographyInline
                          size={"md"}
                          color={GREY.PRIMARY}
                          fontWeight={fontWeight.MEDIUM}
                          label={STRINGS.MOVE_TO_FOLDER}
                        />
                      </Box>
                    </Box>
                    <Box className={classes.moveStyle1}>
                      <SearchField
                        autoComplete="off"
                        size={"sm36"}
                        placeholder={STRINGS.SEARCH_FOLDER}
                        onChange={handleDebounceFolderSearch}
                        onKeyDown={(e) => e.stopPropagation()}
                      />
                    </Box>
                    <Box className={classes.moveDataHeight}>
                      {isLoadData ? (
                        <Box className={classes.containSkeleton}>
                          <FolderSkeletonLoader />
                        </Box>
                      ) : (
                        getMoveData?.map((val, id) => {
                          return (
                            <Box
                              className={
                                isActive === val._id
                                  ? classes.activeMovingContent
                                  : classes.movingContent
                              }
                              onClick={() => backHandle(val._id)}
                            >
                              <IconComponent
                                color={WARNING.W_500}
                                fontSize={fontSize.LG}
                                iconLabel={ICON_LABELS.FOLDER}
                              />
                              <Box
                                className={
                                  isActive === val._id
                                    ? classes.movDataCont1
                                    : classes.movDataCont
                                }
                              >
                                <TypographyInline
                                  size={"sm"}
                                  color={GREY.SECONDARY}
                                  fontWeight={fontWeight.REGULAR}
                                  label={val.name}
                                />
                              </Box>
                            </Box>
                          );
                        })
                      )}
                    </Box>
                    <Box className={classes.movFooter}>
                      <Box className={classes.movCr} onClick={openCreateModal}>
                        <Button
                          label={STRINGS.CREATE_FOLDER}
                          LeftIcon={ICON_LABELS.ADD}
                          size={"sm36"}
                          variant="text"
                        />
                      </Box>

                      <Box className={classes.movBtnGen}>
                        <Button
                          label={STRINGS.COMMON_CANCEL}
                          variant={"ghost"}
                          size={"sm36"}
                          onClick={handleClose}
                        />

                        <Button
                          label={STRINGS.MOVE}
                          size={"sm36"}
                          variant={"primary"}
                          disabled={!isActive?.length}
                          onClick={() => filterMoveTemplate(isActive)}
                          isLoading={isLoad}
                        />
                      </Box>
                    </Box>
                  </Box>
                </CustomStyledMenu>

                {isBulkOperationAllowed() && (
                  <div>
                    <Button
                      label={STRINGS.DELETE}
                      LeftIcon={ICON_LABELS.DELETE}
                      variant={"ghost"}
                      size={"sm36"}
                      onClick={handleBulkDelete}
                      disabled={!isBulkOperationAllowed()}
                    />
                  </div>
                )}
                {id?.length && isBulkOperationAllowed() && (
                  <Box>
                    <Button
                      label={STRINGS.RM_FROM_FOLDER}
                      variant={"ghost"}
                      size={"sm36"}
                      onClick={removeListFolder}
                      disabled={!sortSelector?.data?.checkedRow?.length}
                    />
                  </Box>
                )}
              </Box>
              <Box className={classes.rightDisplay}>
                {!id?.length ? (
                  <Button
                    label={STRINGS.CREATE_FOLD}
                    LeftIcon={ICON_LABELS.CREATE_NEW_FOLDER}
                    variant={"ghost"}
                    size={"sm36"}
                    onClick={handleFolder}
                  />
                ) : null}

                <Button
                  label={STRINGS.CREATE_LIST}
                  LeftIcon={ICON_LABELS.ADD}
                  variant={"primary"}
                  size={"sm36"}
                  onClick={handleListCreate}
                  disabled={!isOperationPermitted}
                />
              </Box>
            </Box>
            <Box className={classes.searchAndTableContainer}>
              <div className={classes.tableStyle}>
                <CustomTable tableData={listTableData} />
              </div>
            </Box>
          </>
        )}
        {open2 && (
          <CreateCommonFolder
            open={open2}
            setOpen={setOpen2}
            endFunction={hitMoveList}
          />
        )}
        {bulkDelete && (
          <BulkDeleteModal
            open={bulkDelete}
            setOpen={setBulkDelete}
            IDs={sortSelector?.data?.checkedRow}
            type={
              getTypeFromIds() === STRINGS.SMALL_FOLDER
                ? STRINGS.BULK_DEL_TYPE
                : STRINGS.DEL
            }
            val={STRINGS.LIST_TEXT}
            itemType={getTypeFromIds()}
          />
        )}
        {showEditModal && (
          <CreateListModal
            open={showEditModal}
            setOpen={setShowEditModal}
            listNameValue={editInitialValue}
            itemId={itemId}
            parent={id}
            permission={viewType || STRINGS.PRIVATE_ID}
          />
        )}
        {showEditModal1 && (
          <CreateCommonFolder
            open={showEditModal1}
            setOpen={setShowEditModal1}
            recordId={myRecord}
            nameFold={myName}
            view={view}
            endFunction={hitMoveList}
          />
        )}
        {showDeleteModal && (
          <ListDeleteFolderModal
            open={showDeleteModal}
            setOpen={setShowDeleteModal}
            name={delName}
            id1={deletePayload}
            folderID={folderEddit}
            val={STRINGS.LIST_CREATE}
          />
        )}
        {showDeleteModal1 && (
          <ListDeleteFolderModal
            open={showDeleteModal1}
            setOpen={setShowDeleteModal1}
            recordId={myRecord}
            name={myName}
            val={STRINGS.COMMON_FOLDER}
          />
        )}

        {removeFolder && (
          <RemoveFolder
            open={removeFolder}
            setOpen={setRemoveFolder}
            IDs={sortSelector?.data?.checkedRow}
            type={STRINGS.LIST_REMT}
            val={STRINGS.LIST_TEXT}
          />
        )}

        {openList && (
          <CreateListModal
            open={openList}
            setOpen={setOpenList}
            permission={permission || STRINGS.PRIVATE_ID}
            parent={id}
          />
        )}
        {/* </Modal> */}
      </Box>
    </>
  );
};

export default ListsScreen;
